import { useCallback } from "react";

import { useFeature, useObjectMemo } from "byzantine";
import User from "byzantine/src/User";

export const useIsNprEnabled = () => {
  const { featureEnabled } = useFeature();
  const isBusinessNprEnabled = featureEnabled(
    "olb_nonpermanent_residents_business"
  );
  const isConsumerNprEnabled = featureEnabled("olb_nonpermanent_residents");

  const isNprEnabled = useCallback(
    (user?: User) => {
      if (user?.user_category === User.BUSINESS) {
        return isBusinessNprEnabled;
      }

      if (user?.user_category === User.PERSONAL) {
        return isConsumerNprEnabled;
      }

      return false;
    },
    [isBusinessNprEnabled, isConsumerNprEnabled]
  );

  return useObjectMemo({
    isNprEnabled,
    isConsumerNprEnabled,
    isBusinessNprEnabled,
  });
};

export default useIsNprEnabled;
